import RightsManagementFailureCode from '../store/schema/RightsManagementFailureCode';
import type IRMRestrictions from '../store/schema/IRMRestrictions';
import type Item from 'owa-service/lib/contract/Item';
import type MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';

export default function getItemRightsManagementRestrictions(item: Item): IRMRestrictions {
    const IRMData = item ? item.RightsManagementLicenseData : null;
    let restrictions = {
        ReplyAllowed: true,
        ReplyAllAllowed: true,
        ForwardAllowed: true,
        PrintAllowed: true,
        CopyAllowed: true,
    } as IRMRestrictions;

    if (
        IRMData &&
        (!IRMData.RightsManagedMessageDecryptionStatus ||
            IRMData.RightsManagedMessageDecryptionStatus == RightsManagementFailureCode.Success)
    ) {
        const {
            ReplyAllowed,
            ReplyAllAllowed,
            ForwardAllowed,
            PrintAllowed,
            ExtractAllowed,
        } = IRMData;
        restrictions = {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (32,13): Type 'boolean | undefined' is not assignable to type 'boolean'.
            // @ts-expect-error
            ReplyAllowed: ReplyAllowed,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (36,13): Type 'boolean | undefined' is not assignable to type 'boolean'.
            // @ts-expect-error
            ReplyAllAllowed: ReplyAllAllowed,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (40,13): Type 'boolean | undefined' is not assignable to type 'boolean'.
            // @ts-expect-error
            ForwardAllowed: ForwardAllowed,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (44,13): Type 'boolean | undefined' is not assignable to type 'boolean'.
            // @ts-expect-error
            PrintAllowed: PrintAllowed,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (48,13): Type 'boolean | undefined' is not assignable to type 'boolean'.
            // @ts-expect-error
            CopyAllowed: ExtractAllowed,
        };
    }

    // Also consider the 'Do Not Forward' flag if this is a meeting request message
    const meetingRequestMessage = item as MeetingRequestMessageType;
    const doNotForwardMeeting = meetingRequestMessage?.DoNotForwardMeeting;
    restrictions.ForwardAllowed = restrictions.ForwardAllowed && !doNotForwardMeeting;

    return restrictions;
}
